import { inject } from '@angular/core';
import { provideAppInitializer } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { FeatureFlagKey, FeatureFlagsService } from '@brighthub/feature-flags';
import { PluginRegistryService } from '@brighthub/plugin';
import { MenuKey, MenuStore } from '@brighthub/shell/data-access-menu';

/**
 * Registers the Ask Navi main navigation entry when {@link FeatureFlagKey.ENABLEASKNAVI} is on.
 * Loaded via `AskNaviModule` from the root application config.
 */
export function provideAskNaviPlugin() {
  return [
    provideAppInitializer(() => {
      const registry = inject(PluginRegistryService);
      registry.registerPlugin(() => {
        const flags = inject(FeatureFlagsService);
        const menuStore = inject(MenuStore);
        void (async () => {
          const enabled = await firstValueFrom(
            flags.getValue$(FeatureFlagKey.ENABLEASKNAVI, false)
          );
          if (enabled === false || enabled === null || enabled === undefined) {
            return;
          }
          menuStore.register({
            id: 'askNavi',
            label: 'Ask Navi',
            icon: 'pi-lightbulb',
            menuKey: MenuKey.MAIN,
            route: '/ask-navi',
            order: 0,
          });
        })();
      });
    }),
  ];
}
